var map = {
	"./contexts/context": 947,
	"./contexts/context.js": 947,
	"./contexts/diff": 946,
	"./contexts/diff.js": 946,
	"./contexts/patch": 949,
	"./contexts/patch.js": 949,
	"./contexts/reverse": 950,
	"./contexts/reverse.js": 950,
	"./date-reviver": 948,
	"./date-reviver.js": 948,
	"./diffpatcher": 943,
	"./diffpatcher.js": 943,
	"./environment": 942,
	"./environment.js": 942,
	"./filters/arrays": 953,
	"./filters/arrays.js": 953,
	"./filters/dates": 955,
	"./filters/dates.js": 955,
	"./filters/lcs": 954,
	"./filters/lcs.js": 954,
	"./filters/nested": 952,
	"./filters/nested.js": 952,
	"./filters/texts": 956,
	"./filters/texts.js": 956,
	"./filters/trivial": 951,
	"./filters/trivial.js": 951,
	"./formatters/annotated": 960,
	"./formatters/annotated.js": 960,
	"./formatters/base": 961,
	"./formatters/base.js": 961,
	"./formatters/console": 962,
	"./formatters/console.js": 962,
	"./formatters/html": 970,
	"./formatters/html.js": 970,
	"./formatters/index": 971,
	"./formatters/index.js": 971,
	"./formatters/jsonpatch": 972,
	"./formatters/jsonpatch.js": 972,
	"./main": 941,
	"./main-formatters": 974,
	"./main-formatters.js": 974,
	"./main-full": 975,
	"./main-full.js": 975,
	"./main.js": 941,
	"./pipe": 945,
	"./pipe.js": 945,
	"./processor": 944,
	"./processor.js": 944
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 959;



//////////////////
// WEBPACK FOOTER
// ./~/jsondiffpatch/src ^\.\/.*$
// module id = 959
// module chunks = 0